import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    // Create a timeline to control the timing of the animations
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".animated-section",  // Trigger animation when section enters viewport
            start: "20% 80%",  // When the section's top reaches 80% of the viewport
            end: "bottom 90%",  // Animation ends when the section's bottom reaches 20% of the viewport
            toggleActions: "play none none reset",  // Play on enter, reset on leaving
            scrub: false,  // Instant animation when triggered
            once: false  // Replay every time section is entered
        }
    });

    // Heading animation
    tl.fromTo(
        ".headingT",
        { x: -200, opacity: 0 },  // Start off-screen left
        {
            x: 0,
            opacity: 1,  // On-screen and fully visible
            duration: 1.5,  // Duration for heading animation
            stagger: 0.3  // Stagger between each heading
        }
    );

    // Paragraph animation: start halfway through the heading animation
    tl.fromTo(
        ".paragraphT",
        { scale: 0.5, opacity: 0 },  // Start small and invisible
        {
            scale: 1,  // Full size
            opacity: 1,  // Fully visible
            duration: 1.5,  // Paragraph animation duration
            stagger: 0.3,  // Stagger between each paragraph
            ease: "power2.out"  // Smooth scaling
        },
        "-=1"  // This overlaps the paragraph animation with the heading animation by 1 second
    );
});




